export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/ai.411a47a.svg";